export default function Cover({ book, w = 130, h = 182, shadow = true, animated = false }) {
    if (book.coverImage || book.img) {
        return (
            <div style={{
                width: w, height: h, borderRadius: 10, position: "relative", overflow: "hidden",
                flexShrink: 0, cursor: "pointer",
                boxShadow: shadow ? `6px 8px 24px ${book.color}55, 2px 2px 8px rgba(0,0,0,0.2)` : "none",
                animation: animated ? "float 4s ease-in-out infinite" : "none",
            }}>
                <img src={book.coverImage || book.img} alt={book.title} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                {/* Spine */}
                <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 6, background: "rgba(0,0,0,0.15)" }} />
            </div>
        );
    }

    return (
        <div style={{
            width: w, height: h, borderRadius: 10, background: book.g, position: "relative", overflow: "hidden",
            flexShrink: 0, cursor: "pointer",
            boxShadow: shadow ? `6px 8px 24px ${book.color}55, 2px 2px 8px rgba(0,0,0,0.2)` : "none",
            animation: animated ? "float 4s ease-in-out infinite" : "none",
        }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "linear-gradient(135deg,rgba(255,255,255,0.15) 0%,transparent 50%,rgba(0,0,0,0.1) 100%)" }} />
            <div style={{ position: "absolute", top: -24, right: -24, width: 80, height: 80, borderRadius: "50%", background: "rgba(255,255,255,0.08)" }} />
            <div style={{ position: "absolute", bottom: -16, left: -16, width: 56, height: 56, borderRadius: "50%", background: "rgba(0,0,0,0.08)" }} />
            <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "12px 10px", textAlign: "center", gap: 8 }}>
                <div style={{ fontSize: w > 100 ? 28 : 20, filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))" }}>{book.emoji}</div>
                <div style={{ color: "white", fontFamily: "'Playfair Display',serif", fontWeight: 700, fontSize: w > 100 ? 11 : 9, lineHeight: 1.3, textShadow: "0 1px 4px rgba(0,0,0,0.4)" }}>
                    {book.title}
                </div>
                <div style={{ color: "rgba(255,255,255,0.7)", fontSize: w > 100 ? 9 : 7, fontStyle: "italic", fontFamily: "'Nunito Sans',sans-serif", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "100%", maxWidth: "100%" }}>
                    {book.author}
                </div>
            </div>
            {/* Spine */}
            <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 6, background: "rgba(0,0,0,0.2)" }} />
        </div>
    );
}

